import { render, staticRenderFns } from "./selectProEduTree.vue?vue&type=template&id=4b84a136&scoped=true&"
import script from "./selectProEduTree.vue?vue&type=script&lang=js&"
export * from "./selectProEduTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84a136",
  null
  
)

export default component.exports